import { render, staticRenderFns } from "./SvgLogoCollectionMobile.vue?vue&type=template&id=dd3830c8&"
import script from "./SvgLogoCollectionMobile.vue?vue&type=script&lang=js&"
export * from "./SvgLogoCollectionMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports